(function () {
  'use strict';

  angular.module('ringbaPortal').component('callRouteForm', {
    bindings: {
      currentCallRoute: '=',
      hideConversion: '<',
      hideDuplicate: '<',
      isRpc: '<'
    },
    controller: CallRouteFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/call-route-form.view.html'
  });

  function CallRouteFormController(
    _,
    infoService,
    utils,
    $filter
  ) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.inputChange = inputChange;
    vm.toggleValueChanged = toggleValueChanged;
    vm.setTranslations = setTranslations;


    function onInit() {
      _initializeCallRoute();
      _loadConversionSettings();
      setTranslations();
      _loadDefaultPriorityDataIfRPC();
    }

    function inputChange() {
      vm.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall = (vm.deDupeSetting.hours * 3600) + (vm.deDupeSetting.days * 86400);
    }

    function toggleValueChanged(callRouteDuplicateToggle) {
      vm.callRouteDuplicateToggle = callRouteDuplicateToggle;
      _toggleChange();
    }

    function setTranslations() {
      if ('postBack' === vm.currentCallRoute.callConversion.conversionType) {
        vm.targetRevenueText =  $filter('translate')('TARGET_ROUTE_REVENUE_POSTBACK');
        vm.targetRevenueTooltipText = $filter('translate')('TARGET_ROUTE_REVENUE_POSTBACK_TT');
      } else {
        vm.targetRevenueText = $filter('translate')('TARGET_ROUTE_REVENUE');
        vm.targetRevenueTooltipText = $filter('translate')('TARGET_ROUTE_REVENUE_TT');
      }
    }

    function _toggleChange() {
      switch (vm.callRouteDuplicateToggle) {
      case -1:
        vm.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall = -1;
        break;
      case 0:
        vm.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall = 0;
        break;
      case 1:
        inputChange();
        break;
      }
    }

    function _initializeCallRoute() {
      if (typeof vm.currentCallRoute === 'undefined' || _.isEmpty(vm.currentCallRoute)) {
        vm.currentCallRoute = {};
      }

      if (vm.currentCallRoute.conversionSettings && vm.currentCallRoute.conversionSettings.length > 0) {
        vm.currentCallRoute.callConversion = vm.currentCallRoute.conversionSettings[0];
        if (vm.currentCallRoute.callConversion.conversionArgs && !vm.currentCallRoute.callConversion.conversionArgs.startTimerEvent) {
          vm.currentCallRoute.callConversion.conversionArgs.startTimerEvent =  'OnConnectedCall';
        }
      } else {
        vm.currentCallRoute.callConversion = { deDupeSetting: { secondsFromLastCall: 0 }, conversionArgs: { startTimerEvent: 'OnConnectedCall' } };
      }
    }

    function _loadConversionSettings() {
      infoService.getConversionSettings()
        .then(function (response) {
          vm.conversionSettings = response.data;
        })
        .catch(utils.errorHandler);
    }

    function _loadDefaultPriorityDataIfRPC() {
      if (!vm.isRpc) {
        return;
      }

      if (!vm.currentCallRoute.priority) {
        vm.currentCallRoute.priority = {};
      }

      if (!vm.currentCallRoute.priority.priority) {
        vm.currentCallRoute.priority.priority = 1;
      }

      if (!vm.currentCallRoute.priority.weight) {
        vm.currentCallRoute.priority.weight = 1;
      }
    }
  }
})();
